<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row flex px-4 gap-4 items-end" style="align-items: center">
          <div class="flex justify-end items-center gap-4" style="flex: 1">

            <vs-button @click="downloadFileWithoutSerial()" class="bg_purple float-right" style="min-width: 180px"
              v-has-permission="permission300">
              <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("DownloadExcelFileWithoutSerial") }}
            </vs-button>
            <vs-button @click="downloadFile()" class="bg_purple float-right" style="min-width: 180px"
              v-has-permission="permission300">
              <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("DownloadExcelFile") }}
            </vs-button>

          </div>
          <div class="flex">
            <div class="w-full">
              <vs-button @click="showFilters = !showFilters" class="bg_purple float-right">
                <div class="px-3">
                  <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" class="ico" />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
        </div>
        <div class="vx-row px-2 flex gap-y-4 items-end pt-4 flex-warp" v-if="showFilters">
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label my-1">{{ $t("Segment") }}</label>
            <v-select label="name" name="segment" :options="allSegment" :reduce="(x) => x.id" v-model="model.segmentIds"
              multiple dir="rtl">
            </v-select>
          </div>

          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label my-1">
              {{ $t("GenericProduct") }}
            </label>

            <v-select label="name" name="GenericProduct" :options="allGenericProducts" :reduce="(x) => x.id"
              v-model="model.GenericProductIds" multiple dir="rtl">
            </v-select>
          </div>

          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label my-1">{{ $t("Brand") }}</label>
            <v-select label="name" name="brand" :options="allBrands" :reduce="(x) => x.id" v-model="model.brandsId"
              multiple dir="rtl">
            </v-select>
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <vs-input v-model="model.stockName" @keyup.enter="search()" placeholder="نام کالا / گارانتی / رنگ"
              :label="$t('StockName')" />
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label">{{ $t("WarehouseName") }}</label>
            <v-select label="name" name="warehouse" :options="allWarehouses" :reduce="(x) => x.id"
              v-model="model.storeIds" multiple dir="rtl">
            </v-select>
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label">{{ $t("ShelveName") }}</label>
            <v-select label="name" v-model="selectedShelve" @input="onShelveSelect" :options="shelves" dir="rtl">
            </v-select>
          </div>


          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <vs-input v-model="model.itemCode" @keyup.enter="search()" :label="$t('ItemCode')" />
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label my-1">{{
              $t("BalanceStatus")
            }}</label>
            <v-select label="name" :options="stockBalanceOptions" v-model="model.stockBalanceFilter"
              :reduce="(x) => x.id" :clearable="false" ref="agentType" dir="rtl">
            </v-select>
          </div>
          <div class="flex gap-4 px-2 flex-grow justify-end">
            <vs-button type="filled" class="float-right" color="#3ec9d6" @click.prevent="resetForm">{{ $t("ResetFilter")
            }}</vs-button>
            <vs-button type="filled" class="float-right" @click.prevent="submitFilter()">{{ $t("SubmitFilter")
            }}</vs-button>
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid :showSum="false" v-has-permission="permission238" ref="grid" stripe :data-source="gridDataSource"
              hasModel :body="model" :columns="[
                { title: $t('StoreName'), sort: 'storeName' },
                { title: $t('ShelveName'), sort: 'shelveName' },
                { title: $t('ProductName'), sort: 'ProductName' },
                { title: $t('ItemCode'), sort: 'ItemCode' },

                {
                  title: $t('LogicalBalance'),
                  sort: 'logicalBalance',
                  total: 'sumOfLogicalBalance',
                },
                {
                  title: $t('PhysicalBalance'),
                  sort: 'physicalBalance',
                  total: 'sumOfPhysicalBalance',
                },
                {
                  title: $t('CostOfGoodsPurchased'),
                  sort: 'CostOfGoodsPurchased',
                },
                {
                  title: $t('SumCostOfGoodsPurchased'),
                  sort: 'SumCostOfGoodsPurchased',
                  total: 'totalSumOfCostOfGoodsPurchased',

                },
                { title: $t('Action') },
              ]">
              <template slot-scope="{ row }">
                <td style="width: 10%">
                  {{ row.storeName }}
                </td>
                <td style="width: 10%">
                  {{ row.shelveName }}
                </td>
                <td style="width: 18%" :title="row.stockName">
                  {{ row.stockName | truncate(120) }}
                </td>
                <td style="width: 12%">
                  {{ row.itemCode }}
                </td>

                <td style="width: 10%">
                  {{ row.logicalBalance }}
                </td>
                <td style="width: 10%">
                  {{ row.physicalBalance }}
                </td>
                <td style="width: 10%">
                  {{
                    row.costOfGoodsPurchased
                      ? Number(row.costOfGoodsPurchased).toLocaleString() + " ریال"
                      : 0
                  }}
                </td>
                <td style="width: 10%">
                  {{
                    row.sumOfCostOfGoodsPurchased
                      ? Number(row.sumOfCostOfGoodsPurchased).toLocaleString() + " ریال"
                      : 0
                  }}
                </td>
                <td style="width: 10%; min-width: 135px">
                  <span>
                    <vs-button color="primary" type="border" icon-pack="feather" icon="icon-eye"
                      class="custom-border-btn" v-has-permission="'GetAllSerialsInfoInTotalStore'"
                      @click="viewSerials(row.storeId, row.itemCode)">{{ $t("ViewSerials") }}</vs-button>
                  </span>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
    <serials-list-partial-popup :show="SerialsListPopup" @finish="closeSerialsListPopup"
      :popupService="popupService"></serials-list-partial-popup>
  </div>
</template>

<style lang="scss">
.con-slot-tabs>* {
  transition: none !important;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import utils from "@/assets/utils/index";
import vSelect from "@/components/CustomVSelect.vue";
import SerialsListPartialPopup from "../CheckOutTransactions/SerialsListPartialPopup.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "warehouseManagement_Balance_DividedByWarehouseAndShelve",
  components: {
    DataGrid,
    "v-select": vSelect,
    SerialsListPartialPopup,
  },
  data() {
    return {
      showFilters: false,
      permission238: "GetAllInventoryBalances",
      permission300:
        "GetAllInventoriesStocksBalancesWithStoresAndShelvesByExcelFile",
      gridDataSource: {
        type: "app",
        method: "post",
        service: "Inventory/api/InventoryTransactionsQuery",
      },
      model: {
        stockBalanceFilter: 1,
        segmentIds: [],
        GenericProductIds: [],
        storeIds: [],
      },
      shelves: [],
      allSegment: [],
      SerialsListPopup: false,
      popupService: "",
      selectedStore: {},
      selectedShelve: {},
      stockBalanceOptions: [
        { name: "همه", id: 0 },
        { name: "موجود", id: 1 },
        { name: "ناموجود", id: 2 },
      ],
    };
  },
  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/listWithShelves",
      allBrands: "brand/list",
      allGenericProducts: "genericProduct/list",
    }),
  },

  mounted() {
    this.fetchWarehouses().then(() => {
      this.warehousesLoading = false;
    });
    this.showListAllBrands();
    this.showListOfSegment();
    this.showListAllGenericProducts();
  },

  methods: {
    ...mapActions({
      exportDividedByWarehousesAndShelveExcel: "excel/exportDividedByWarehousesAndShelveExcel",
      exportDividedByWarehousesAndShelveExcelWithoutSerial: "excel/exportDividedByWarehousesAndShelveExcelWithoutSerial",
      fetchWarehouses: "warehouse/fetchList",
      showListAllBrands: "brand/fetchNoSkip",
      showListAllSegment: "warehouse/fetchSegment",
      showListAllGenericProducts: "genericProduct/fetchNoSkip",
    }),

    showListOfSegment() {
      this.showListAllSegment().then((result) => {
        this.allSegment = result;
      });
    },
    downloadFile() {
      this.exportDividedByWarehousesAndShelveExcel(this.model);
    },
    downloadFileWithoutSerial() {
      this.exportDividedByWarehousesAndShelveExcelWithoutSerial(this.model);
    },
    getShelves(id) {
      this.resetShelves();
      let selectWarehouse = this.getWarehouseWith(id);
      let shelveQueries = this.getShelveFrom(selectWarehouse);
      shelveQueries.forEach((shelves) => {
        shelves.forEach((shelve) => this.shelves.push(shelve));
      });
    },
    getWarehouseWith(id) {
      return this.allWarehouses.filter((warehouse) => warehouse.id == id);
    },
    getShelveFrom(warehouse) {
      return warehouse.map(({ shelveQueries }) => shelveQueries);
    },
    resetShelves() {
      this.shelves = [];
      this.resetSelectedShelve();
    },
    resetSelectedShelve() {
      this.selectedShelve = {};
      this.model.shelveId = null;
    },
    resetSelectedStore() {
      this.selectedStore = {};
      this.model.storeId = null;
    },
    onSelectWarehouse(warehouse) {
      if (warehouse) {
        this.model.storeId = warehouse.id;
        this.getShelves(warehouse.id);
      } else {
        this.resetSelectedStore();
        this.resetShelves();
      }
    },
    onShelveSelect(shelve) {
      if (shelve) {
        this.model.shelveId = shelve.id;
      } else {
        this.resetSelectedShelve();
      }
    },
    submitFilter() {
      this.$refs.grid.renderGrid();
    },
    viewSerials(storeId, itemCode) {
      let url = `/Inventory/api/InventoryTransactionsQuery/serial-info-in-inventory-balance-for/${storeId}/${itemCode}`;

      this.popupService = url;
      this.SerialsListPopup = true;
    },
    closeSerialsListPopup() {
      this.SerialsListPopup = false;
    },
    onfinish() {
      this.closeSerialsListPopup();
      this.$refs.grid.renderGrid();
    },
    resetForm() {
      this.model = {};
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
      this.resetSelectedShelve();
      this.resetSelectedStore();
    },
  },
};
</script>
